<div class="edit-field-image-selector">
  <div
    class="edit-field-image-selector__image-drop-zone"
    (drop)="onDropFile($event)"
    (dragover)="onDragOverFile($event)"
  >
    <div class="edit-field-image-selector__image">
      @if (!object[field.name].value || object[field.name].value === ('None')) {
        <i class="edit-field-image-selector__image-icon icon-image"></i>
      }
      @else {
        <div class="edit-field-image-selector__image-container">
          <app-thumbnail
            [item]="object[field.name]"
            [imageIdField]="'value'"
            [stylingClass]="'image-uploaded-edit'"
            [showUploadStatus]="true"
          ></app-thumbnail>

          <a
            class="edit-field-image-selector__image-delete"
            (click)="deleteImage()"
          >
            <i class="icon-trash"></i>
          </a>
        </div>
      }
    </div>

    <div class="edit-field-image-selector__text">
      <h5 class="bold">
        {{ 'TRANS__IMAGE_SELECTOR__DRAG_AND_DROP_FILE_HERE' | translate }}
      </h5>

      <span class="edit-field-image-selector__passive-text">
        {{ 'TRANS__IMAGE_SELECTOR__OR' | translate }}
      </span>
    </div>
  </div>

  <div class="edit-field-image-selector__button">
    <button
      mat-stroked-button
      type="button"
      color="primary"
    >
      <label for="upload_file">
        <i class="icon-upload"></i>

        @if (computer) {
          <span class="bold">
            {{ 'TRANS__IMAGE_SELECTOR__UPLOAD_IMAGE' | translate }}
          </span>
        }
        @else {
          <span class="bold">
            {{ 'TRANS__IMAGE_SELECTOR__CHANGE_IMAGE_AND_CAMERA' | translate }}
          </span>
        }
      </label>
    </button>

    <input
      type="file"
      id="upload_file"
      (change)="onFileSelect($event)"
    >
  </div>
</div>
